(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cvv-back-in-stock"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-cvv-restock]');

    roots.forEach((root) => {
      if (root.dataset.cvvRestockReady === 'true') return;
      root.dataset.cvvRestockReady = 'true';

      const buyButtons = root.closest('.buy-buttons');
      const productForm = buyButtons?.querySelector('product-form');
      const toggle = root.querySelector('[data-cvv-restock-toggle]');
      const panel = root.querySelector('[data-cvv-restock-panel]');
      const form = root.querySelector('.cvv-restock__form');
      const frame = root.querySelector('[data-cvv-restock-frame]');
      const tagsInput = root.querySelector('[data-cvv-restock-tags]');
      const fields = root.querySelector('[data-cvv-restock-fields]');
      const submit = root.querySelector('.cvv-restock__submit');
      const message = root.querySelector('[data-cvv-restock-message]');
      let awaitingFrame = false;

      if (form && frame?.name) {
        form.setAttribute('target', frame.name);
      }

      const getAddButton = () => productForm?.querySelector('[ref="addToCartButton"]');

      const getVariantId = () => {
        const addButton = getAddButton();
        const variantInput = productForm?.querySelector('[ref="variantInput"]');
        return addButton?.getAttribute('data-variant-id') || variantInput?.value || root.dataset.initialVariantId || '';
      };

      const update = () => {
        const addButton = getAddButton();
        const variantId = getVariantId();
        const soldOut = Boolean(addButton?.disabled && variantId);

        root.hidden = !soldOut;

        if (!soldOut) {
          panel.hidden = true;
          toggle?.setAttribute('aria-expanded', 'false');
        }

        if (tagsInput && variantId) {
          tagsInput.value = 'back_in_stock,product_' + root.dataset.productId + ',variant_' + variantId;
        }
      };

      const showSuccess = () => {
        fields.hidden = true;
        message.hidden = false;
        message.textContent = root.dataset.successMessage || '';
        message.classList.remove('is-error');
        message.classList.add('is-success');
        toggle.textContent = root.dataset.subscribedLabel || '';
        toggle.disabled = true;
      };

      toggle?.addEventListener('click', () => {
        const opening = panel.hidden;
        panel.hidden = !opening;
        toggle.setAttribute('aria-expanded', String(opening));

        if (opening) {
          panel.querySelector('input[type="email"]')?.focus();
        }
      });

      form?.addEventListener('submit', () => {
        if (!form.checkValidity()) return;

        awaitingFrame = true;
        submit.disabled = true;
        message.hidden = true;
        message.classList.remove('is-success', 'is-error');
      });

      frame?.addEventListener('load', () => {
        if (!awaitingFrame) return;
        awaitingFrame = false;

        let success = false;

        try {
          const frameDocument = frame.contentDocument;
          const frameUrl = frame.contentWindow?.location?.href || '';
          success =
            Boolean(frameDocument?.querySelector('[data-cvv-restock-posted="true"]')) ||
            frameUrl.includes('customer_posted=true');
        } catch (error) {
          success = false;
        }

        submit.disabled = false;

        if (success) {
          showSuccess();
          return;
        }

        message.hidden = false;
        message.textContent = root.dataset.errorMessage || '';
        message.classList.remove('is-success');
        message.classList.add('is-error');
      });

      const observer = new MutationObserver(update);
      if (productForm) {
        observer.observe(productForm, {
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'data-variant-id', 'value']
        });
      }

      document.addEventListener('change', (event) => {
        if (buyButtons?.parentElement?.contains(event.target)) {
          requestAnimationFrame(update);
        }
      });

      if (root.querySelector('[data-cvv-restock-posted="true"]')) {
        panel.hidden = false;
        toggle?.setAttribute('aria-expanded', 'true');
        showSuccess();
      }

      update();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cvv-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.querySelector('[data-cvv-newsletter-popup]');
    if (!popup || typeof popup.showModal !== 'function') return;

    const key = 'cvv_newsletter_popup_snooze_until';
    const closeButton = popup.querySelector('[data-cvv-popup-close]');
    const successMarker = popup.querySelector('[data-cvv-popup-success="true"]');
    const successPanel = popup.querySelector('[data-cvv-popup-success-panel]');
    const formContent = popup.querySelector('[data-cvv-popup-form-content]');
    const title = popup.querySelector('[data-cvv-popup-title]');
    const form = popup.querySelector('#CvvNewsletterPopupForm');
    const frame = popup.querySelector('[data-cvv-newsletter-frame]');
    const submitButton = popup.querySelector('[data-cvv-popup-submit]');
    const birthdayInput = popup.querySelector('[data-cvv-popup-birthday]');
    const tagsInput = popup.querySelector('[data-cvv-popup-tags]');
    const ajaxError = popup.querySelector('[data-cvv-popup-ajax-error]');
    const copyButton = popup.querySelector('[data-cvv-popup-copy]');
    const codeElement = popup.querySelector('[data-cvv-popup-code]');
    let awaitingFrame = false;
    const now = Date.now();
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    const snoozeUntil = Number(localStorage.getItem(key) || 0);

    const snooze = (days) => {
      localStorage.setItem(key, String(Date.now() + days * 24 * 60 * 60 * 1000));
    };

    const closePopup = () => {
      snooze(7);
      popup.close();
    };

    const setSubmitLoading = (loading) => {
      if (!submitButton) return;

      submitButton.disabled = loading;
      submitButton.textContent = loading
        ? submitButton.dataset.cvvLoadingLabel
        : submitButton.dataset.cvvDefaultLabel;
    };

    const showSuccess = () => {
      snooze(180);

      if (title) title.hidden = true;
      if (formContent) formContent.hidden = true;
      if (successPanel) successPanel.hidden = false;

      setSubmitLoading(false);
    };

    closeButton?.addEventListener('click', closePopup);

    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });

    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup();
    });

    form?.addEventListener('submit', () => {
      if (!form.checkValidity()) return;

      const birthday = birthdayInput?.value || '';

      if (tagsInput && birthday) {
        const monthDay = birthday.slice(5);
        tagsInput.value = [
          'newsletter',
          'popup',
          'birthday',
          'birthdate_' + birthday,
          'birthday_' + monthDay
        ].join(',');
      }

      awaitingFrame = true;
      form.setAttribute('aria-busy', 'true');
      setSubmitLoading(true);

      if (ajaxError) {
        ajaxError.hidden = true;
        ajaxError.textContent = '';
      }
    });

    frame?.addEventListener('load', () => {
      if (!awaitingFrame) return;

      awaitingFrame = false;
      form?.removeAttribute('aria-busy');

      let submittedSuccessfully = false;
      let errorText = '';

      try {
        const frameDocument = frame.contentDocument;
        const frameUrl = frame.contentWindow?.location?.href || '';

        submittedSuccessfully =
          Boolean(frameDocument?.querySelector('[data-cvv-popup-success="true"]')) ||
          frameUrl.includes('customer_posted=true');

        if (!submittedSuccessfully) {
          errorText =
            frameDocument
              ?.querySelector('.cvv-newsletter-popup__errors')
              ?.textContent
              ?.trim() || '';
        }
      } catch (error) {
        submittedSuccessfully = false;
      }

      if (submittedSuccessfully) {
        showSuccess();
        return;
      }

      setSubmitLoading(false);

      if (ajaxError) {
        ajaxError.textContent = errorText || '';
        ajaxError.hidden = !errorText;
      }
    });

    copyButton?.addEventListener('click', async () => {
      const code = codeElement?.textContent?.trim();
      if (!code) return;

      try {
        await navigator.clipboard.writeText(code);
        copyButton.textContent = popup.dataset.cvvCopiedText || copyButton.textContent;
      } catch (error) {
        return;
      }
    });

    if (successMarker) {
      snooze(180);
      showSuccess();
      setTimeout(() => {
        if (!popup.open) popup.showModal();
      }, 100);
      return;
    }

    if (designMode || now >= snoozeUntil) {
      setTimeout(() => {
        if (!popup.open) popup.showModal();
      }, designMode ? 350 : 3500);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
